<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_DocumentsBack')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="takeBackDialog.dataLabel">
            <el-date-picker
              v-model="takeBackDialog.backDate"
              type="date"
              :editable="false"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button no="confirm" type="primary" @click="takeBackSave">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="takeBackDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { checkChargeWriteoffClear, batchBackFileHandler } from '@/api/seaExport/file'
import $store from '@/store'

export default {
  name: 'DcTakeBackWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    takeBackDialog: { type: Object, required: true },
    selectedFiles: { type: Array, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    // 批量取回 -保存
    takeBackSave() {
      if (this.takeBackDialog.backDate) {
        const fileList = []
        for (const file of this.selectedFiles) {
          file.state = 2
          file.backDate = this.takeBackDialog.backDate
          file.backUser = $store.getters.userId
          fileList.push(file)
        }
        // 调用后端保存
        batchBackFileHandler(fileList).then(res => {
          const params = { jobUuid: this.job.uuid, event: 'back_file_charge_writeoff' }
          checkChargeWriteoffClear(params)
          this.$emit('successHandler', fileList)
          this.$message.success(this.$t('CargoMsg.Cargo_GoBackSuccess'))
          this.takeBackDialog.visible = false
        })
      }
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      const start = ColumnUtils.dateLabelFunc(currDate)
      const end = ColumnUtils.dateLabelFunc(this.takeBackDialog.startDate)
      return start < end
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

